export default __webpack_public_path__ + "static/media/pic7.0c02aae3.jpg";